//namespace
window.QJTApp = window.QJTApp || { modules: {} };

/**
 * Módulo de interação com formulários
 *
 * @module Forms
 */
window.QJTApp.modules.Publishing = (function ($) {
	'use strict';
	var imagesDropzone,
		filesDropzone;

	/**
	 * Faz a chamada ajax via método GET
	 *
	 * @private
	 * @method callByGet
	 * @param {String} url A url que deve ser chamada via ajax.
	 * @param {Function} callback O callback a ser chamado quando se obtém a resposta com sucesso do servidor.
	 */
	var callByGet = function(url, callback) {
		console.log('callByGet...');
		$.get(url, callback).fail(onCallByGetFail);
	}

	/**
	 * Faz a chamada ajax via método GET
	 *
	 * @private
	 * @method onCallByGetFail
	 * @param {Object} data Objeto que contém as informações do erro.
	 */
	var onCallByGetFail = function(data) {
		console.log('onCallByGetFail: falha no ajax via get...');
		console.log(data);
	}

	/**
	 * Retorna a string que representa o evento 'transitionend' correto,
	 * dependendo do browser.Função de
	 * David Walsh: http://davidwalsh.name/css-animation-callback
	 *
	 * @private
	 * @method whichTransitionEvent
	 */
	var whichTransitionEvent = function(){
		var t,
			el = document.createElement("fakeelement");

		var transitions = {
			'transition'				: 'transitionend',
			'OTransition'				: 'oTransitionEnd',
			'MozTransition'			: 'transitionend',
			'WebkitTransition' 	: 'webkitTransitionEnd'
		}

		for (t in transitions){
			if (el.style[t] !== undefined){
				return transitions[t];
			}
		}
	}
	
	/**
	 * Callback chamado na inicialização da Dropzone
	 *
	 * @private
	 * @method onDropzoneInit
	 */
	var onDropzoneInit = function() {
		console.log('onDropzoneInit...');

		//guarda a referência do escopo principal da dropzone
		filesDropzone = this;

		var length = 0;
		
		$('.dz-loading').one(whichTransitionEvent(), function(event) {
			console.log('transitionEnd...');

			//consulta se existem arquivos para este post
			callByGet('posts/listFile/' + $('#formPost').data('id'), onListFilesSuccess);
		});
		$('.dz-loading').css('opacity', 1);
		
		//escutando os eventos
		filesDropzone.on('addedfile', 		onDropzoneAddedFile);
		filesDropzone.on('removedfile', 	onDropzoneRemovedFile);
		filesDropzone.on('sending', 		onDropzoneBeforeUpload);
		filesDropzone.on('success', 		onDropzoneFileUploaded);
		filesDropzone.on('error', 			onDropzoneFileError);
		filesDropzone.on('queuecomplete', 	onDropzoneQueueComplete);
	}

	/**
	 * Callback chamado quando é retornada com sucesso a lista de arquivos do servidor.
	 *
	 * @private
	 * @method onListFilesSuccess
	 * @param
	 */
	var onListFilesSuccess = function(files) {

		$('.dz-loading').one(whichTransitionEvent(), function(event) {
			console.log('transitionEnd...');

			//se a resposta for diferente de null...
			if(files !== null) {

				//verifica se existem arquivos na resposta...
				if(files.length > 0) {
						
					length += files.length;

					//mostra o número de arquivos existentes na tab de imagens 
					$('#ins-images-tab .badge').append(length);

					//desabilita a tab de vídeo e mostra mensagem caso ela seja clicada
					$('#ins-video-tab').addClass('disabled');
					$('#ins-video-tab > a')
					.attr({ href: '#'})
					.removeAttr('data-toggle')
					.click(function(e){
						e.preventDefault();
						$.growl.error({ title: "Ops!", message: 'Infelizmente foto(s) e vídeo simultaneamente em uma mesma publicação ainda não são permitidos.' });
					});
				}

				//varre cada um dos arquivos retornados na resposta
				$.each(files, function(key, value){

					// crefte the mock file:
					var mockFile = { name: value.url_arquivo, size: value.size, id: value.id_arquivo };

					//emite o evento para que o callback seja chamado e adicione o arquivo
					filesDropzone.emit("addedfile", mockFile);

					//adiciona o arquivo no array da dropzone para guardar em memória
					filesDropzone.files.push(mockFile);

					//emite o evento para que o respectivo callback seja chamado e adicione o thumbnail
					filesDropzone.emit("thumbnail", mockFile, 'uploads/id'+value.id_site+'/galerias/thumb_'+value.url_arquivo);
				});

			} else {
				//mostra a mensagem da dropzone
				$('.dz-default').css('opacity', 1);
			}
		});
		
		$('.dz-loading').css('opacity', 0);
	}

	/**
	 * Callback chamado quando um arquivo é adicionado.
	 *
	 * @private
	 * @method onDropzoneAddedFile
	 * @param
	 */
	var onDropzoneAddedFile = function(file) {

		if(file.hasOwnProperty('status')) {
			$(file.previewElement).find('.dz-edit').css('display', 'none');
			$(file.previewElement).find('.dz-remove').css('display', 'none');
		}

		//apenas para dar efeito de fade
		$(file.previewElement).addClass('dz-added');

		$(file.previewElement).attr('data-id', file.id);
		$(file.previewElement).find('.dz-size > span').html(bytesToSize(file.size));

		$(file.previewElement).find('.dz-edit').attr('href', 'editar_arquivo/index/' + file.id);

		//ação do botão 'remover'
		$(file.previewElement).find('.dz-remove').on('click', function(e) {
			e.preventDefault();

			var succesMark = $(e.currentTarget).parents('.dz-preview').find('.dz-success-mark');
			succesMark.css('opacity', 0);

			//armazena a div que exibe o loader de carregamento da imagem
			var currentProcessingMark = $(e.currentTarget).parents('.dz-preview').find('.dz-processing-mark');

			//vincula um callback para ser chamado no evento transitionend da transição de CSS
			currentProcessingMark.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function(){
				

				//remove todo e qualquer listener do processing loader
				currentProcessingMark.unbind();

				console.log($(e.currentTarget).parents('.dz-preview'));

				var currentElement = $(e.currentTarget).parents('.dz-preview');
				var id = currentElement.data('id');

				$.get('posts/delFile/' + id, function(data) {

					if(data.status === 1) {

						currentElement.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function(){

							//remove todo e qualquer listener do elemento
							currentElement.unbind();

							filesDropzone.removeFile(file);
						});

						currentElement.css('opacity', 0);
						
					} else {
						console.log('falha na remoção do arquivo - posts_editar_view.php:480');
					}
				}).fail(onCallByGetFail);
			});
			
			//aplica à div que exibe o loader de carregamento da imagem a opacidade que sofrerá a transição
			currentProcessingMark.css('opacity', 1);
		});

	}

	/**
	 * Callback chamado na remoção de um arquivo.
	 *
	 * @private
	 * @method onDropzoneRemovedFile
	 * @param
	 */
	var onDropzoneRemovedFile = function(file) {
		console.log('arquivo removido!');

		//alert(file.id +' '+ file.filename);
		//ajax call to delete from DB image with id = file.id
		//ajax call to delete from server  image with id = file.filename
		//$('input[name="addimage[]"][value="'+file.id+'"]').remove();

		length--;

		//mostra o número de arquivos existentes na tab de imagens 
		$('#ins-images-tab .badge').html(length);
	}

	/**
	 * Callback chamado antes do início de um upload.
	 *
	 * @private
	 * @method onDropzoneBeforeUpload
	 * @param
	 * @param
	 * @param
	 */
	var onDropzoneBeforeUpload = function(file, xhr, formData) {
		console.log('sending...');
				
		//formData.append('lenght', lenght);
	}

	/**
	 * Callback chamado no sucesso do upload de um arquivo.
	 *
	 * @private
	 * @method onDropzoneFileUploaded
	 * @param
	 * @param
	 */
	var onDropzoneFileUploaded = function(file, response) {
		console.log('success...');

		console.log(response);
		console.log(file);

		/*file.id = response.id;
		file.filename = response.filename;*/

		$(file.previewElement).attr('data-id', response.id);
		$(file.previewElement).find('.dz-filename > span').html(response.filename);
		$(file.previewElement).find('.dz-size > span').html(bytesToSize(response.size));
		$(file.previewElement).find('.dz-edit').attr('href', 'editar_arquivo/index/' + response.id);
		$(file.previewElement).find('.dz-edit').css('display', 'inline-block');
		$(file.previewElement).find('.dz-remove').css('display', 'inline-block');

		length++;

		//mostra o número de arquivos existentes na tab de imagens 
		$('#ins-images-tab .badge').html(length);
	}

	/**
	 * Retorna o peso do arquivo no formato visual adequado.
	 *
	 * @private
	 * @method bytesToSize
	 * @param {Number} bytes O peso do arquivo em bytes.
	 */
	var bytesToSize = function(bytes) {
		if(bytes == 0) return '0 Byte';
		var k = 1000;
		var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		var i = Math.floor(Math.log(bytes) / Math.log(k));
		return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
	}

	/**
	 * Callback chamado no erro ou impossibilidade do upload de um arquivo.
	 *
	 * @private
	 * @method onDropzoneFileError
	 * @param
	 * @param
	 * @param
	 */
	var onDropzoneFileError = function(file, errorMessage, xhr) {
		console.log(errorMessage);

		console.log($(file.previewElement).find('.dz-actions > a').remove());
	}

	/**
	 * Callback chamado quando todos os arquivos da fila foram processados.
	 *
	 * @private
	 * @method onDropzoneQueueComplete
	 * @param
	 */
	var onDropzoneQueueComplete = function(file) {
		console.log('queuecomplete - lenght: ' + length);
	}

	//API aberta
	return {

		/**
		 * Inicia o Módulo.
		 *
		 * @method init
		 */
		init: function () {

			$('.switchers').switcher({
				on_state_content: '<span class="fa fa-check" style="font-size:11px;"></span>',
				off_state_content: '<span class="fa fa-times" style="font-size:11px;"></span>'
			});

			//QJT-TODO: Implementar a possibilidade de publicações com vídeo.
			//desabilita a tab de vídeo temporariamente.
			$('#ins-tabs > li.disabled > a').attr('data-toggle' , '').click(function(e) {
				e.preventDefault();
			});

			

			//limpa a modal dinâmica de edição de imagens sempre que ela for fechada.
			$('#modal-cropping').on("hidden.bs.modal", function (e) {
				console.log('fechou modal!');
				$(e.target).removeData("bs.modal").find(".modal-content").empty();
			});

			//ação do botão "excluir" no topo da página.
			$('#post-delete').on('click', function(e) {
				e.preventDefault();

				var $modal  = $('#warn-modal').clone(true);
				$modal.find('.modal-footer > a.btn').attr('href', $(e.currentTarget).data('method'));
				$modal.modal('show').on('hidden.bs.modal', function(e) {
					$(e.currentTarget).remove()
				})
			});

			//ação do botão "salvar" no topo da página.
			$('#post-save').on('click', function(e) {
				e.preventDefault();
				
				var form = $(e.currentTarget).parents('form');
				var textContent = $('#post-text').code();
				var hasText = (textContent.replace(/(<([^>]+)>)/ig,'') == '')? false : true;

				
				if(!hasText) {
					if(imagesDropzone.files.length <= 0) {

						var msg = '<button type="button" class="close" data-dismiss="alert">×</button><strong>Ops!</strong> Para publicar é necessário ao menos anexar uma imagem. Ou se você não pretende anexar nenhuma imagem, pelo menos escreva algo no campo "Texto" abaixo.';
						
						$('.alert').html(msg).css('display', 'block');
					} else {
						$('textarea[name="texto"]').html(textContent);
						submitForm(form);
					}
				} else {
					$('textarea[name="texto"]').html(textContent);
					submitForm(form);
				}

				function submitForm(currentForm) {
					currentForm.submit();
				}

			});

			//tooltips nos campos de data e hora.
			$('.input-group-addon').tooltip();

			if ( $('#dt_inicio').is('[readonly]') ) {
				//...
			} else {
				//datepicker para o campo de data.
				$('#dt_inicio').datepicker({
					//forceParse: true,
					format: 'dd/mm/yyyy',
					language: 'pt-BR',
					todayHighlight: true
				});

				//timepicker para o campo de hora.
				$('#hr_inicio').timepicker({
					minuteStep: 1,
					showSeconds: true,
					showMeridian: false,
					showInputs: false,
					orientation: $('body').hasClass('right-to-left') ? { x: 'right', y: 'auto'} : { x: 'auto', y: 'auto'}
				});
			}
			
			//limitador de caracteres para o campo "título".
			$("#post_title").limiter(140, { label: '#post_title_limiter' });

			//editor do campo de texto da publicação.
			$('#post-text').summernote({
				height: 200,
				lang: 'pt-BR',
				tabsize: 2,
				toolbar: [
					['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
					['color', ['color']],
					['layout', ['ul', 'ol', 'paragraph']],
					['insert', ['link']],
					['misc', ['undo', 'redo']]
				]
			});

			//função de validação de dados do campo de data (formato brasileiro).
			$.validator.addMethod(
				'dateBR',
				function(value, element) {  
					var check = false;  
					var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;  
					if( re.test(value)) {  
						var adata = value.split('/');  
						var gg = parseInt(adata[0],10);  
						var mm = parseInt(adata[1],10);  
						var aaaa = parseInt(adata[2],10);  
						var xdata = new Date(aaaa,mm-1,gg);  
						if( ( xdata.getFullYear() == aaaa ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == gg ) )  {
							check = true;  
						} else {
							check = false;  
						}
					} else {
						check = false;
					}
					return this.optional(element) || check;
				},
				'Insira uma data válida'
			);

			//valida os campos de data e hora.
			$('#formPost').validate({
				rules: {
					dt_inicio: {
						required: true,
						dateBR: true
					},
					hr_inicio: {
						required: true
					}
				},
				messages: {
					dt_inicio: {
						required: 'campo obrigatório.'
					},
					hr_inicio: {
						required: 'campo obrigatório.'
					}
				}
			});
			
			//upload de arquivos.
			imagesDropzone = new Dropzone('div#images-dropzone', {
				url:  'posts/addFile/' + $('#formPost').data('id'),
				paramName: 'url_arquivo', // The name that will be used to transfer the file
				maxFilesize: 2, // MB
				//addRemoveLinks : true,
				//dictRemoveFile: 'Remover',
				//autoProcessQueue: false,
				dictFileTooBig: 'Tamanho acima do máximo permitido (2Mb).',
				dictResponseError: 'Arquivo não foi enviado!',
				thumbnailWidth: 138,
				thumbnailHeight: 120,
				acceptedFiles: '.png,.jpg',

				previewTemplate: '<div class="dz-preview"><div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div><div class="dz-size">Tamanho: <span data-dz-size></span></div></div><div class="dz-thumbnail-wrapper"><img data-dz-thumbnail><span class="dz-nopreview">Sem Pré-visualização</span><div class="progress progress-striped active"><div class="progress-bar progress-bar-success" data-dz-uploadprogress></div></div><div class="dz-processing-mark"><img src="images/loader-spinning-white.svg" width="30" height="30"></div><div class="dz-success-mark"><i class="fa fa-check-circle"></i></div><div class="dz-error-mark"><i class="fa fa-times-circle-o"></i></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div><div class="dz-actions"><a href="#" class="dz-edit btn btn-info btn-xs btn-outline" data-toggle="modal" data-target="#modal-cropping"><span class="fa fa-pencil"></span>&nbsp;Editar</a><a href="#" class="dz-remove btn btn-danger btn-xs btn-outline"><span class="fa fa-times"></span>&nbsp;Remover</a></div></div>',
				init: onDropzoneInit,

				//revisar essa função
				resize: function(file) {
					var info = { srcX: 0, srcY: 0, srcWidth: file.width, srcHeight: file.height },
						srcRatio = file.width / file.height;
					if (file.height > this.options.thumbnailHeight || file.width > this.options.thumbnailWidth) {
						info.trgHeight = this.options.thumbnailHeight;
						info.trgWidth = info.trgHeight * srcRatio;
						if (info.trgWidth > this.options.thumbnailWidth) {
							info.trgWidth = this.options.thumbnailWidth;
							info.trgHeight = info.trgWidth / srcRatio;
						}
					} else {
						info.trgHeight = file.height;
						info.trgWidth = file.width;
					}
					return info;
				}
			});
		}
	}

})(jQuery);

//start
window.QJTApp.modules.Publishing.init();
